import { AppImage } from 'types';

export enum EMarketHelpModals {
  ADD_EDIT_CATEGORY = 'add_edit_category',
  ADD_EDIT_QUESTION = 'add_edit_question',
  CONFIRM = 'confirm',
}

export enum EMarketHelpModalAction {
  DELETE_CATEGORY = 'delete_category',
  DELETE_QUESTION = 'delete_question',
}

export interface MarketHelpModalPayload {
  action?: EMarketHelpModalAction;
}

export interface IMarketHelpModal {
  type: EMarketHelpModals;
  payload?: MarketHelpModalPayload;
}

export interface IHelpLanguage {
  id: number;
  locale: string;
  code: string;
  name: string;
}

export interface IHelpQuestion {
  id: number;
  question: string;
  answer: string;
}

export interface IHelpCategory {
  id: number;
  name: string;
  language: IHelpLanguage;
  icon: AppImage | null;
  position_index: number;
  questions: IHelpQuestion[];
  model_type: string;
}

export interface GetCategoriesPayload {
  language_id: number;
}

export interface GetCategoryPayload {
  id: number;
}

export interface DeleteCategoryPayload extends GetCategoryPayload {}

export interface DeleteCategoryQuestionPayload {
  id: number;
  category_id: number;
}

export interface AddCategoryPayload {
  name: string;
  language_id: number;
  position_index?: number;
}

export interface EditCategoryPayload extends AddCategoryPayload {
  id: number;
}

export interface UpdateCategoriesOrderPayload {
  order: { id: number; position_index: number }[];
}

export interface AddCategoryQuestionPayload {
  question: string;
  answer: string;
  category_id: number;
}

export interface UpdateCategoryQuestionPayload extends AddCategoryQuestionPayload {
  id: number;
}
